module.exports = __webpack_public_path__ + "assets/img/edit_propname.185ad65a.png";